var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1000002799(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
    fill: "white",
    stroke: "#BD6A01",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.55 7.00055H11.2838L11.192 9.37641H10.9533L10.8528 7.00055H10.5683L10.4765 9.37641H10.2378L10.146 7.00055H9.85229L9.7605 9.37641H9.52184L9.42179 7.00055H9.16523L9 10.1574C9.00905 10.4095 9.09006 10.6502 9.22948 10.8392C9.30714 10.9396 9.40063 11.0204 9.50455 11.0771C9.60847 11.1338 9.72074 11.1652 9.83485 11.1694V16.5816C9.83717 16.6916 9.87467 16.7964 9.93959 16.8742C10.0045 16.9521 10.0919 16.997 10.1837 16.9998H10.5141C10.6059 16.997 10.6933 16.9521 10.7582 16.8742C10.8231 16.7964 10.8606 16.6916 10.8629 16.5816V11.1694C11.092 11.154 11.308 11.0362 11.4683 10.8392C11.6142 10.6551 11.6962 10.4113 11.6978 10.1574L11.55 7.00055ZM14.6324 7.00055C14.5724 7.00217 14.5135 7.021 14.4608 7.05547C14.4081 7.08994 14.3631 7.13905 14.3295 7.19868C14.2753 7.27856 14.2262 7.36318 14.1826 7.45184C13.3372 9.1348 13.1187 13.4138 13.1187 13.4138H13.9719V16.6146C13.9766 16.7187 14.0145 16.8168 14.0777 16.8884C14.1409 16.9601 14.2246 17 14.3116 16.9998H14.6512C14.7397 17.0029 14.8258 16.9643 14.8909 16.8923C14.9561 16.8203 14.9952 16.7207 15 16.6146V7.44028C15 7.38246 14.9905 7.32521 14.9721 7.27179C14.9536 7.21837 14.9266 7.16984 14.8925 7.12895C14.8584 7.08807 14.8179 7.05564 14.7733 7.03351C14.7288 7.01139 14.681 7 14.6328 7L14.6324 7.00055Z",
    fill: "#BD6A01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1000002799);
export default __webpack_public_path__ + "static/media/Frame1000002799.ce2fca0dfbc892eda30bde3e09b4e9a1.svg";
export { ForwardRef as ReactComponent };